GlamCornerCore.bus.on("dates-changed", ({ startDate, endDate }) => {
  GlamCornerCore.gcSession.setSessionValues({ startDate, endDate });
});
